class ProductStageSlider {
    constructor (element, options) {
        const defaults = {
            resizeTimeout: 150
        };

        this.settings = Object.assign({}, defaults, options);

        this.$slider = element;
    }

    initialize () {
        const initSlider = (Slider) => {
            const imageSlider = new Slider(this.$slider, {
                speed: 500,
                indicators: true,
                prevnext: false,
                slidesPerView: 1,
                slidesPerGroup: 1,
                initAttr: 'data-productstage'
            });

            this.$slider.API = imageSlider;
        };

        import('../../components/slider/slider').then(({ Slider }) => {
            initSlider(Slider);
        });
    }
}

export { ProductStageSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productStageSliders = $context.querySelectorAll('[data-productstage="slider"]');

        if ($productStageSliders.length > 0) {
            for (let i = 0; i < $productStageSliders.length; i++) {
                const $productStageSlider = new ProductStageSlider($productStageSliders[i]);
                $productStageSlider.initialize();
            }
        }
    }
});
